import { render, staticRenderFns } from "./pagination1.vue?vue&type=template&id=0e90ba56&scoped=true"
import script from "./pagination1.vue?vue&type=script&lang=js"
export * from "./pagination1.vue?vue&type=script&lang=js"
import style0 from "./pagination1.vue?vue&type=style&index=0&id=0e90ba56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90ba56",
  null
  
)

export default component.exports